export const useBlockScroll = () => {
  const { width } = useWindowSize();
  const isMobile = computed(() => width.value < 768);

  const toggleBlockScroll = (open: boolean) => {
    const main = document.querySelector("main");
    if (isMobile.value && open) {
      main?.style.setProperty("height", "0", "important");
      main?.style.setProperty("overflow-y", "hidden", "important");
    } else if (!open) {
      main?.style.removeProperty("height");
      main?.style.removeProperty("overflow-y");
    }
  };

  watch(isMobile, (newVal) => {
    if (!isMobile.value) {
      toggleBlockScroll(false);
    } else {
      toggleBlockScroll(true);
    }
  });

  onUnmounted(() => {
    toggleBlockScroll(false);
  });

  return { toggleBlockScroll };
};
